import ConfirmRegistration from "./confirm-registration";
import Login from "./login";
import Register from "./register";

export default Login;
export {
    ConfirmRegistration, Register
}
